import { useEffect, useState } from 'react'
import AppRoutes from 'routes'
import { styled, CssBaseline } from '@mui/material'
import { connect, useDispatch } from 'react-redux'
import AppLoader from 'components/ui-kit/AppLoader'
import AppToaster from 'components/ui-kit/AppToaster'
import { LOADER_TYPE } from 'utils/constants'
// import { ErrorBoundary } from 'react-error-boundary'
// import ErrorHandler from 'components/layout/ErrorHandler/index'
import { getRolePermissionsService, getAdminDetailsService, checkIpWhitelistService } from 'network/services/admins.service'
import { setPermissions } from 'redux-thunk/redux/Permissions/permissionsSlice'
import { getAuthToken, getOperatorRole, signOut } from 'utils/common-services/cookie.services'
import { setAdminUserDetails } from 'redux-thunk/redux/Auth/authSlice'

const App = ({ pageLoading }) => {
  const dispatch = useDispatch()
  const [ipAllowed, setIpAllowed] = useState(true)
  const [ipChecked, setIpChecked] = useState(false)

  useEffect(() => {
    const init = async () => {
      try {
        const token = getAuthToken()

        if (token) {
          try {
            const role = getOperatorRole()

            const checkRes = await checkIpWhitelistService({ role })

            // ✅ if not allowed, sign out and show access denied
            if (checkRes?.allowed === false) {
              signOut() // 👈 clear cookies
              setIpAllowed(false)
            } else {
              setIpAllowed(true)
            }
          } catch (err) {
            console.error('IP check error:', err)
            setIpAllowed(true)
          }

          try {
            const adminDetails = await getAdminDetailsService()
            dispatch(setAdminUserDetails(adminDetails))
            const roleId = adminDetails?.roleId
            if (roleId) {
              const permissions = await getRolePermissionsService({ roleId })
              dispatch(setPermissions(permissions))
            }
          } catch (err) {
            console.error('load permissions error:', err)
          }
        } else {
          setIpAllowed(true)
        }
      } catch (err) {
        console.error('init error:', err)
        setIpAllowed(true)
      } finally {
        setIpChecked(true)
      }
    }

    init()
  }, [])

  // 👇 show loader while checking - blocks everything
  if (!ipChecked) {
    return (
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh'
      }}
      >
        <AppLoader variant={LOADER_TYPE.SCALE} />
      </div>
    )
  }

  return (
    <>
      <CssBaseline />
      {pageLoading &&
        <StyledLoaderDiv>
          <AppLoader variant={LOADER_TYPE.SCALE} />
        </StyledLoaderDiv>}
      <StyledBodyContainer pageloading={pageLoading ? 1 : 0}>
        <AppToaster />
        <AppRoutes
          pageLoader={pageLoading}
          ipAllowed={ipAllowed}
          ipChecked={ipChecked}
        />
      </StyledBodyContainer>
    </>
  )
}

const StyledLoaderDiv = styled('div')(({ theme }) => ({
  position: 'fixed',
  top: '50%',
  left: '50%',
  zIndex: 1
}))

const StyledBodyContainer = styled('div')(({ theme, pageloading }) => (pageloading
  ? { filter: 'blur(3px)' }
  : {}))

const mapStateToProps = (state) => {
  return {
    pageLoading: state.loader.pageLoader
  }
}

export default connect(mapStateToProps)(App)
